import React from "react";
import styled from "@emotion/styled";
import UseFocus, { useMountEffect } from "../../hooks/useFocus";

interface IconButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  css?: string;
  children: any;
  selected?: boolean;
  isHeader?: boolean;
  theme?: any;
}

export const IconButton: React.FC<IconButtonProps> = ({
  css,
  children,
  onClick,
  disabled,
  isHeader = false,
  selected,
  theme,
  ...rest
}) => {
  const [closeRef, setCloseFocus] = UseFocus();
  const CustomSpan = styled.span`
    ${css}
    cursor: ${disabled ? "not-allowed" : "pointer"};
    opacity: ${disabled ? 0.5 : 1};
  `;

  useMountEffect(setCloseFocus);
  const handleKeypress = (e: React.KeyboardEvent) => {
    if (e.charCode === 13 && onClick) {
      onClick();
    }
  };

  const handleOnClick = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  return (
    <CustomSpan
      onKeyPress={handleKeypress}
      ref={closeRef}
      onClick={handleOnClick}
      tabIndex={0}
      className={` ${isHeader ? "header-icon" : "icon-button"} ${css && css} `}
    >
      {children}
    </CustomSpan>
  );
};
